import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { CustomButton } from '@medtronic/pecc-react-component-library-js';
import { Box, FormControlLabel, Modal, Switch, Typography } from '@mui/material';
import { useDeactivateProjectMutation } from '~/api/v2/hooks';
import { ModalHeader } from '~/components';
import { modalActionBlockStyles, modalSmallContainerStyle } from '~/components/styles';
import { useAppDispatch } from '~/redux';
import { closeModalById } from '~/redux/slices/modalSlice';
import { removeButtonStyles } from '../../DatasetDetailsPage/components/DatasetModal/styles';
import { deactivateDescrContainerStyles } from './styles';

const deactivateDescription = [
  ' Before you proceed with deactivating this project, please ensure that you have saved all artifacts associated with this project.',
  'Upon deactivation, all temporary data within the project will be deleted.',
  'Are you sure you want to deactivate the project?',
];

const DeactivateProjectModal = ({ id }: { id: string }) => {
  const projectId = +useParams().projectid!;
  const dispatch = useAppDispatch();
  const [deactivateProject, { isLoading: isEditingProject }] = useDeactivateProjectMutation({
    fixedCacheKey: `deactivate-project-${projectId}`,
  });
  const [confirmed, setConfirmed] = useState<boolean>(false);

  const handleClose = () => {
    dispatch(closeModalById(id));
  };

  const handleDeactivate = async () => {
    await deactivateProject({ projectId });
    handleClose();
  };

  return (
    <Modal open onClose={handleClose}>
      <Box tabIndex={-1} sx={modalSmallContainerStyle}>
        <ModalHeader onClose={handleClose} title={['Deactivate this project?']} style={{ color: 'green' }} />
        <Box sx={deactivateDescrContainerStyles}>
          {deactivateDescription.map((desc) => (
            <Typography key={desc} variant="bodyLarge" component="div">
              {desc}
            </Typography>
          ))}
          <FormControlLabel
            labelPlacement="end"
            label="I understand and wish to proceed with this action"
            control={
              <Switch onChange={() => setConfirmed(!confirmed)} disabled={isEditingProject} sx={{ mx: '1rem' }} />
            }
          />
        </Box>
        <Box sx={modalActionBlockStyles}>
          <CustomButton label="Cancel" buttonType="borderless" onClick={handleClose} />
          <CustomButton label="Deactivate" disabled={!confirmed} onClick={handleDeactivate} sx={removeButtonStyles} />
        </Box>
      </Box>
    </Modal>
  );
};

export default DeactivateProjectModal;
